import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, forkJoin, lastValueFrom, takeWhile } from 'rxjs';
import { AlertService } from 'src/app/alert/services/alert.service';
import { BaseService } from 'src/app/base.service';
import { AlertTitles, AlertTypes, AppSide, AppStatesTexts, errorMsgsPopup, MNGAuthUrls, MNGUrls } from 'src/app/constants';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AddPartnerDataModel, CreateAppDataModel, CreateVendorDataModel } from '../models/managementModel';
const MNG_USER_KEY = 'mng-user-details-auth';
const MNG_TOKEN_KEY = 'mng-app-token';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'src/app/shared/shared.service';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/shared/services/storage.service';
import { WebhookDefData } from 'src/app/shared/models/sharedModel';

@Injectable({
  providedIn: 'root'
})
export class ManagementService implements OnDestroy {

  isMngLoggedIn = new Subject();

  destroySubscription = false;

  inviteCodePopupSubject = new Subject();

  partnersListDataSub = new Subject();

  // singlePartnerDataSub = new Subject();

  // updatePartnerDataSub = new Subject();

  vendorsListDataSub = new Subject();

  createVendorDataSub = new Subject();

  singleVendorDataSub = new Subject();

  // vendorAppsListDataSub = new Subject();

  createVendorAppDataSub = new Subject();

  appDocsDataSub = new Subject();

  // appDocsUploadDataSub = new Subject();

  appImageUrlsDataSub = new Subject();

  singleVendorAppDataSub = new Subject();

  singleVendorAppDataSubA = new Subject();

  vendorEditClickSub = new Subject();

  domaintiersDataSub = new Subject();

  tiersDataSub = new Subject();

  uploadImgDataSub = new Subject();

  domainTiersUpdateDataSub = new Subject();

  tiersUpdateDataSub = new Subject();

  deleteAppDataSub = new Subject();

  associatedPartnersListDataSub = new Subject();

  removeAllManageGridParams = new Subject();

  constructor(private baseService: BaseService, private alertService: AlertService,
    private router: Router, private spinner: NgxSpinnerService,
    private sharedService: SharedService) { }

  mngAuthLogin() {
    window.location.href = JSON.parse(JSON.stringify(MNGUrls.mngAppAuthUrl));
  }

  public saveMngUser(user: any): void {
    this.removeMngUser()
    window.localStorage.setItem(MNG_USER_KEY, JSON.stringify(user));

  }

  public getMngUser(): any {
    const user = window.localStorage.getItem(MNG_USER_KEY);
    if (user && user !== 'undefined') {
      return JSON.parse(user);
    }
    return null;
  }

  public removeMngUser() {
    window.localStorage.removeItem(MNG_USER_KEY);
  }

  public saveMngToken(tokenObj: any): void {
    this.removeMngUser()
    window.localStorage.setItem(MNG_TOKEN_KEY, JSON.stringify(tokenObj));

  }

  public getMngToken(): any {
    const user = window.localStorage.getItem(MNG_TOKEN_KEY);
    if (user && user !== 'undefined') {
      return JSON.parse(user);
    }
    return null;
  }

  public removeMngToken() {
    window.localStorage.removeItem(MNG_TOKEN_KEY);
  }

  getMetadataNBrandingData() {
    this.spinner.show();
    const responseA = this.getDataForkJoinSkipIntercept(MNGUrls.metadata);
    const responseB = this.getDataForkJoinWithToken(MNGUrls.mngUserInfo);
    forkJoin([responseA, responseB])
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && forkResponse.length) {
          if (forkResponse[0] && forkResponse[0].status === 200 && forkResponse[0].body) {
            this.sharedService.appMetaDataSub.next(forkResponse[0].body);
            this.sharedService.saveMetadata(forkResponse[0].body);

          }
          if (forkResponse[1] && forkResponse[1].status === 200 && forkResponse[1].body) {
            this.saveMngUser(forkResponse[1].body);
          }

          this.isMngLoggedIn.next(true);
          // this.router.navigate(['/manage/partner']);
          this.defaultManageLoadScreen();
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  defaultManageLoadScreen() {
    // this.router.navigate(['/manage/partner']);
    this.router.navigate(['/manage/appstates']);
  }

  getDataForkJoinSkipIntercept(reqUrl: string) {
    return this.baseService.getDataForkJoinSkipIntercept(reqUrl);
  }

  getPartnersList() {
    this.getRequest(MNGUrls.getPartnersList)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.partnersListDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.partnersListDataSub.next(null);
        }
      });
  }

  // getPartner(partner_id: string) {
  //   this.getRequest(MNGUrls.partnerBase + partner_id)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.singlePartnerDataSub.next(response.body);
  //         }
  //       },
  //       error: (err: any) => {
  //         this.singlePartnerDataSub.next(null);
  //       }
  //     });
  // }

  // updatePartner(updatePartnerDataModel: any) {
  //   Object.keys(updatePartnerDataModel).forEach(key => {
  //     if (updatePartnerDataModel[key] === '') {
  //       delete updatePartnerDataModel[key];
  //     }
  //   });
  //   const updatePartnerDataModelNew = JSON.parse(JSON.stringify(updatePartnerDataModel));
  //   updatePartnerDataModelNew.contact_num = (String(updatePartnerDataModelNew.contact_num)).replace(/[-\(\)\.\s\+]/g, '');
  //   this.putRequest(updatePartnerDataModelNew, MNGUrls.partnerBaseA + '/' + updatePartnerDataModel.partner_id)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           const obj = {
  //             alertType: 'autoClose',
  //             icon: AlertTypes.success,
  //             title: AlertTitles.successTitle
  //           }
  //           this.alertService.alertSubject.next(obj);

  //           this.updatePartnerDataSub.next(obj);
  //         }
  //       }
  //     });
  // }

  deletePartners(selectedPartnersData: any) {
    const alertText = 'Delete partner ' + selectedPartnersData.partner_name + '.';
    this.alertService.alertConfirmCommon(AlertTitles.areYouSureTitle, alertText, AlertTypes.question,
      '', '', true).then((result) => {
        if (result.isConfirmed) {
          this.deleteRequest(MNGUrls.partnerBase + selectedPartnersData.partner_id)
            .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
              next: (response: any) => {
                if (response && response.status === 200) {
                  this.getPartnersList();
                  const obj = {
                    alertType: 'autoClose',
                    icon: AlertTypes.success,
                    title: AlertTitles.deletedTitle,
                    text: ''
                  }
                  this.alertService.alertSubject.next(obj);
                }
              },
              error: (err: any) => {

              }
            });
        }
      });
  }

  createPartner(addPartnerData: AddPartnerDataModel) {
    this.postRequest(addPartnerData, MNGUrls.createPartnerInvite)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            const obj = {
              alertType: 'openSwal',
              icon: AlertTypes.info,
              text: errorMsgsPopup.codeSentTo + ' ' + addPartnerData.recipient_email
            }
            this.alertService.alertSubject.next(obj);

            this.inviteCodePopupSubject.next(obj);
          }
        }
      });
  }

  createVendor(createVendorDataModel: CreateVendorDataModel, isUpdateVendor: boolean) {
    const createVendorDataModelNew = JSON.parse(JSON.stringify(createVendorDataModel));
    createVendorDataModelNew.contact_num = (String(createVendorDataModelNew.contact_num)).replace(/[-\(\)\.\s\+]/g, '');
    if (isUpdateVendor) {
      this.putRequest(createVendorDataModelNew, MNGUrls.vendorBase + '/' + createVendorDataModel.vendor_id)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              const obj = {
                alertType: 'autoClose',
                icon: AlertTypes.success,
                title: AlertTitles.successTitle
              }
              this.alertService.alertSubject.next(obj);
              this.getVendorsList();
              this.createVendorDataSub.next(true);
            }
          }
        });
    } else {
      this.postRequest(createVendorDataModelNew, MNGUrls.vendorBase)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              const obj = {
                alertType: 'autoClose',
                icon: AlertTypes.success,
                title: AlertTitles.successTitle
              }
              this.alertService.alertSubject.next(obj);
              this.getVendorsList();
              this.createVendorDataSub.next(true);
            }
          }
        });
    }
  }

  getVendorsList() {
    this.getRequest(MNGUrls.getVendorsList)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.vendorsListDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.vendorsListDataSub.next(null);
        }
      });
  }

  getVendor(vendor_name: string) {
    const url = MNGUrls.vendorBase + '?vendor-name=' + vendor_name;
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.singleVendorDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.singleVendorDataSub.next(null);
        }
      });
  }

  deleteVendor(selectedVendorsData: any) {
    const alertText = 'Delete vendor ' + selectedVendorsData.vendor_name + '.';
    this.alertService.alertConfirmCommon(AlertTitles.areYouSureTitle, alertText, AlertTypes.question,
      '', '', true).then((result) => {
        if (result.isConfirmed) {
          this.deleteRequest(MNGUrls.vendorBase + '/' + selectedVendorsData.vendor_id)
            .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
              next: (response: any) => {
                if (response && response.status === 200) {
                  this.getVendorsList();
                  const obj = {
                    alertType: 'autoClose',
                    icon: AlertTypes.success,
                    title: AlertTitles.deletedTitle,
                    text: ''
                  }
                  this.alertService.alertSubject.next(obj);
                }
              },
              error: (err: any) => {

              }
            });
        }
      });
  }

  // getVendorAppsList(vendor_id: string) {
  //   this.getRequest(MNGUrls.listAppsManage + '?vendor-id=' + vendor_id)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.vendorAppsListDataSub.next(response.body);
  //         }
  //       },
  //       error: (err: any) => {
  //         this.vendorAppsListDataSub.next(null);
  //       }
  //     });
  // }

  async getVendorApps(urlParams?: any) {
    
    // let reqUrl = MNGUrls.listAppsManage + '?vendor-id=' + vendor_id + '&';

    let reqUrl = MNGUrls.listAppsManage;
    
    try {
      return await lastValueFrom(
        this.getData(reqUrl, urlParams.length ? urlParams : '')
      )
    }
    catch (e) {
      return null;
    }
  }

  getVendorAppDetails(app_id: string) {
    this.getRequest(MNGUrls.vendorAppBase + '/' + app_id)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.singleVendorAppDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.singleVendorAppDataSub.next(null);
        }
      });
  }

  getVendorAppDetailsA(app_id: any) {
    this.getRequest(MNGUrls.vendorAppBase + '/' + app_id)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.singleVendorAppDataSubA.next(response.body);
          }
        },
        error: (err: any) => {
          this.singleVendorAppDataSubA.next(null);
        }
      });
  }

  createVendorApp(createAppDataModel: CreateAppDataModel, vendor_id: string, isCreateApp: boolean) {
    const reqObj = {
      app_id: createAppDataModel.app_id,
      app_name: createAppDataModel.app_name,
      app_secret: createAppDataModel.app_secret,
      description: createAppDataModel.description,
      short_description: createAppDataModel.short_description,
      vendor_id: vendor_id,
      vendor_app_fqdn: createAppDataModel.vendor_app_fqdn,
      user_mgmt_enabled: createAppDataModel.user_mgmt_enabled,
      user_tiers_enabled: createAppDataModel.user_tiers_enabled,
      domain_mgmt_enabled: createAppDataModel.domain_mgmt_enabled,
      domain_tiers_enabled: createAppDataModel.domain_tiers_enabled,
      app_type: createAppDataModel.app_type, // createAppDataModel.app_type === 'PRODUCTIVITY/COLLABORATION' ? 'PRODUCTIVITY_OR_COLLABORATION' : createAppDataModel.app_type,
      auth_type: createAppDataModel.auth_type,
      app_status: createAppDataModel.app_status,
      geospec: createAppDataModel.geospec,
      promoted_app: createAppDataModel.promoted_app,
      // Only send promo_rank when the app is promoted. Default to 100 on create,
      // and also on update when the app has no existing rank yet (i.e. it is
      // being newly promoted during the update); otherwise keep its current rank.
      ...(createAppDataModel.promoted_app && {promo_rank: createAppDataModel.promo_rank ?? 100})
    }
    if (isCreateApp) {
      delete reqObj.app_id;
      delete reqObj.app_status;
      this.postRequest(reqObj, MNGUrls.vendorAppBase)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              this.createVendorAppDataSub.next(response.body);
            }
          }
        });
    } else {
      this.putRequest(reqObj, MNGUrls.vendorAppBase + '/' + createAppDataModel.app_id)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              this.createVendorAppDataSub.next(response.body);
            }
          }
        });
    }
  }


  getAppDocs(app_id: string | undefined) {
    const url = MNGUrls.vendorAppBase + '/' + app_id + '/app-documents?upload-status=COMPLETE';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.appDocsDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.appDocsDataSub.next(null);
        }
      });
  }



  getImageUploadUrls(app_id: any) {
    const url = MNGUrls.vendorAppBase + '/' + app_id + '/image-urls';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.appImageUrlsDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.appImageUrlsDataSub.next(null);
        }
      });
  }

  createVendorAppImg(createAppDataModel: CreateAppDataModel) {
    if (createAppDataModel.app_icon_file && createAppDataModel.app_image_file) {
      this.spinner.show();
      const response = this.putDataForkJoinSkipIntercept(createAppDataModel.app_icon_file, createAppDataModel.app_icon_upload_url);
      const responseA = this.putDataForkJoinSkipIntercept(createAppDataModel.app_image_file, createAppDataModel.app_image_upload_url);

      forkJoin([response, responseA])
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
          if (forkResponse && forkResponse.length) {
            this.spinner.hide();
            this.uploadImgDataSub.next(true);
          }
        }, (error) => {
          console.log('error at service', error);
          this.spinner.hide();
          const obj = {
            alertType: 'openSwal',
            icon: AlertTypes.error,
            text: errorMsgsPopup.uploadFailed
          }
          this.alertService.alertSubject.next(obj);
        });
    } else if (createAppDataModel.app_icon_file) {
      this.uploadVendorAppImages(createAppDataModel.app_icon_file, createAppDataModel.app_icon_upload_url);
    } else if (createAppDataModel.app_image_file) {
      this.uploadVendorAppImages(createAppDataModel.app_image_file, createAppDataModel.app_image_upload_url);
    } else {

    }
  }

  uploadVendorAppImages(file: any, uploadUrl: any) {
    this.putRequest(file, uploadUrl)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.uploadImgDataSub.next(true);
          }
        }
      });
  }

  getDomainTiers(app_id: any) {
    const url = MNGUrls.vendorAppBase + '/' + app_id + '/tiers?tier-level=DOMAIN';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.domaintiersDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.domaintiersDataSub.next(null);
        }
      });
  }

  postDomainTiers(createAppDataModel: CreateAppDataModel) {
    let tiersArr: any = [];
    if (createAppDataModel.tiersArrDomain && createAppDataModel.tiersArrDomain.length) {
      createAppDataModel.tiersArrDomain.forEach(item => {
        if (item.name) {
          tiersArr.push(item.name);
        }
      })
    } else {
      tiersArr = [];
    }
    const tempObj = {
      tier_level: 'DOMAIN',
      tier_names: tiersArr
    }
    const tiersUpdateUrl = MNGUrls.vendorAppBase + '/' + createAppDataModel.app_id + '/tiers';
    this.putRequest(tempObj, tiersUpdateUrl)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.domainTiersUpdateDataSub.next(true);
          }
        }
      });
  }

  getTiers(app_id: any) {
    const url = MNGUrls.vendorAppBase + '/' + app_id + '/tiers?tier-level=USER';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.tiersDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.tiersDataSub.next(null);
        }
      });
  }

  postTiers(createAppDataModel: CreateAppDataModel) {
    let tiersArr: any = [];
    if (createAppDataModel.tiersArr && createAppDataModel.tiersArr.length) {
      createAppDataModel.tiersArr.forEach(item => {
        if (item.name) {
          tiersArr.push(item.name);
        }
      })
    } else {
      tiersArr = [];
    }
    const tempObj = {
      tier_level: 'USER',
      tier_names: tiersArr
    }
    const tiersUpdateUrl = MNGUrls.vendorAppBase + '/' + createAppDataModel.app_id + '/tiers';
    this.putRequest(tempObj, tiersUpdateUrl)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.tiersUpdateDataSub.next(true);
          }
        }
      });
  }

  // createVendorAppPosAction() {
  //   const obj = {
  //     type: AlertTypes.success,
  //     text: 'Success'
  //   }
  // }

  deleteVendorApp(selectedVendorAppsData: any) {
    const alertText = 'Delete app ' + selectedVendorAppsData.app_name + '.';
    this.alertService.alertConfirmCommon(AlertTitles.areYouSureTitle, alertText, AlertTypes.question,
      '', '', true).then((result) => {
        if (result.isConfirmed) {
          this.deleteRequest(MNGUrls.vendorAppBase + '/' + selectedVendorAppsData.app_id)
            .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
              next: (response: any) => {
                if (response && response.status === 200) {
                  const obj = {
                    alertType: 'autoClose',
                    icon: AlertTypes.success,
                    title: AlertTitles.deletedTitle,
                    text: ''
                  }
                  this.alertService.alertSubject.next(obj);
                  this.deleteAppDataSub.next(true);
                }
              },
              error: (err: any) => {

              }
            });
        }
      });
  }

  async getAssociatedPartnersListData(app_id: string) {
    // const reqUrl = MNGUrls.partnerBase + 'partners?app-id=' + app_id;
    const reqUrl = MNGUrls.appStates + '?app-id=' + app_id;
    // this.getRequest(reqUrl)
    //   .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
    //     next: (response: any) => {
    //       if (response && response.status === 200) {
    //         this.associatedPartnersListDataSub.next(response.body);
    //       }
    //     },
    //     error: (err: any) => {
    //       this.associatedPartnersListDataSub.next(null);
    //     }
    //   });
    try {
      return await lastValueFrom(
        this.getData(reqUrl)
      )
    }
    catch (e) {
      return null;
    }
  }

  async getPartnerApps(params: any) {
    const reqUrl = MNGUrls.appStates;
    try {
      return await lastValueFrom(
        this.getData(reqUrl, params)
      )
    }
    catch (e) {
      return null;
    }
  }

  logout() {
    this.removeAllManageGridParams.next(true);
    this.sharedService.removeMetadata();
    this.removeMngUser();
    this.removeMngToken();
    if (environment.envIndicator) {
      // window.location.href = MNGAuthUrls.logoutNormal + '?returnTo=' + environment.webAppUrl;
      window.location.href = MNGAuthUrls.logoutNormal + '?returnTo=' + window.location.origin // + '/manage';
    } else {
      // window.location.href = MNGAuthUrls.logout;
      window.location.href = MNGAuthUrls.logoutNormal + '?returnTo=' + window.location.origin // + '/manage';
    }

  }

  getData(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any, index: any) => {
        // console.log(index);
        if (index === 0) {
          urlData += '?' + val.paramLabel + '=' + val.paramValue
        } else {
          urlData += '&' + val.paramLabel + '=' + val.paramValue;
        }

      });
    }
    return this.baseService.getData(reqUrl + (urlData ? urlData : ''));
  }

  getRequest(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.getData(reqUrl + (urlData ? urlData : ''));
  }

  postRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.postData(reqObj, reqUrl + (urlData ? urlData : ''));
  }


  deleteRequest(deleteUrl: string, urlParams?: any, id?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.deleteRequest(deleteUrl + (urlData ? urlData : ''));
  }

  putRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.putData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  patchRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.patchData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  getDataForkJoinWithToken(reqUrl: string) {
    return this.baseService.getDataForkJoinWithToken(reqUrl);
  }

  postDataForkJoinWithToken(reqObj: any, reqUrl: string) {
    return this.baseService.postDataForkJoinWithToken(reqObj, reqUrl);
  }

  putDataForkJoinSkipIntercept(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.putDataForkJoinSkipIntercept(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  getDataText(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.getDataText(reqUrl + (urlData ? urlData : ''));
  }

  deleteRequestForkJoinWithToken(reqUrl: string) {
    return this.baseService.deleteRequestForkJoinWithToken(reqUrl);
  }

  postRequestForkJoinWithFormData(contentType: any, reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.postRequestForkJoinWithFormData(contentType ? contentType : '', reqObj, reqUrl);
  }

  goHome() {
    this.router.navigate(['/manage']);
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }
}
